export const FORMAT: Record<string, string> = {
  DAY_AND_MONTH_FULL: 'DD MMMM',
  DATE_FULL: 'YYYY-MM-DD',
}
